module.exports = function() {
  return new Worker(__webpack_public_path__ + "cafb36debd9e3dd88689.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader/dist/cjs.js!./src/services/templateWorker.js
// module id = 2331
// module chunks = 1